(function () {
  'use strict';

  function initRainbowChordSolo(section) {
    var video = section.querySelector('[data-rainbow-video]');
    var soundButton = section.querySelector('[data-rainbow-sound]');
    var pauseButton = section.querySelector('[data-rainbow-pause]');
    var fallbackButton = section.querySelector('[data-rainbow-fallback]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var isInView = false;
    var isLoaded = false;

    if (!video || !soundButton || !pauseButton) return;

    var soundOnLabel = section.dataset.labelSoundOn || 'Turn sound on';
    var soundOffLabel = section.dataset.labelSoundOff || 'Turn sound off';
    var playLabel = section.dataset.labelPlay || 'Play video';
    var pauseLabel = section.dataset.labelPause || 'Pause video';

    section.classList.add('rainbow-ready');
    section.dataset.sound = 'off';
    section.dataset.playing = 'false';

    function syncControls() {
      var isPlaying = !video.paused && !video.ended;
      section.dataset.playing = isPlaying ? 'true' : 'false';
      section.dataset.sound = video.muted ? 'off' : 'on';
      soundButton.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      soundButton.setAttribute('aria-label', video.muted ? soundOnLabel : soundOffLabel);
      pauseButton.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      pauseButton.setAttribute('aria-label', isPlaying ? pauseLabel : playLabel);
    }

    function loadVideo() {
      if (isLoaded) return;
      video.src = video.dataset.rainbowSrc;
      video.load();
      isLoaded = true;
    }

    function playVideo() {
      loadVideo();
      var request = video.play();
      if (request && typeof request.catch === 'function') {
        request.catch(function () {
          syncControls();
        });
      }
    }

    function pauseVideo() {
      video.pause();
      syncControls();
    }

    function muteVideo() {
      video.muted = true;
      syncControls();
    }

    soundButton.addEventListener('click', function () {
      loadVideo();
      video.muted = !video.muted;
      if (video.paused) playVideo();
      syncControls();
    });

    pauseButton.addEventListener('click', function () {
      if (video.paused) playVideo();
      else pauseVideo();
    });

    video.addEventListener('click', function () {
      if (video.paused) playVideo();
      else pauseVideo();
    });

    video.addEventListener('play', syncControls);
    video.addEventListener('pause', syncControls);
    video.addEventListener('volumechange', syncControls);
    video.addEventListener('canplay', function () {
      section.classList.remove('is-error');
    });
    video.addEventListener('error', function () {
      section.classList.add('is-error');
      syncControls();
    });

    if (fallbackButton) {
      fallbackButton.addEventListener('click', function () {
        section.classList.remove('is-error');
        video.load();
        playVideo();
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target !== section) return;
        isInView = entry.isIntersecting && entry.intersectionRatio >= 0.2;
        if (entry.isIntersecting) section.classList.add('is-visible');

        if (!isInView) {
          pauseVideo();
          muteVideo();
          return;
        }

        loadVideo();
        if (!reducedMotion.matches) {
          video.muted = true;
          playVideo();
        }
      });
    }, { threshold: [0, 0.2, 0.55], rootMargin: '120px 0px 120px' });

    observer.observe(section);

    function handleMotionPreference() {
      if (reducedMotion.matches) {
        pauseVideo();
        muteVideo();
      } else if (isInView) {
        video.muted = true;
        playVideo();
      }
    }

    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', handleMotionPreference);
    } else if (typeof reducedMotion.addListener === 'function') {
      reducedMotion.addListener(handleMotionPreference);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pauseVideo();
        muteVideo();
      }
    });

    syncControls();
  }

  document.querySelectorAll('[data-rainbow-chord-solo]').forEach(initRainbowChordSolo);
})();
